"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.datePickerTheme = void 0;
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var muiTheme_1 = __importDefault(require("../../../styles/muiTheme"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        chevron: {
            marginTop: -14,
            marginRight: 8,
            cursor: 'pointer',
        },
        icon: {
            margin: '-4px 16px -4px -2px',
        },
        datePicker: {
            padding: '18px 24px',
        },
        menuList: {
            padding: '8px 0px',
            margin: 0,
            listStyle: 'none',
        },
    });
});
exports.datePickerTheme = (0, core_1.createTheme)(__assign(__assign({}, muiTheme_1.default), { overrides: {
        MuiPickersCalendarHeader: {
            switchHeader: {
                marginBottom: 24,
            },
            transitionContainer: {
                height: theme_1.default.fonts.headline3.lineHeight,
                '& p': __assign({}, theme_1.default.fonts.headline3),
            },
            dayLabel: __assign({ color: theme_1.default.textColors.primaryLight }, theme_1.default.fonts.label1),
            iconButton: {
                color: theme_1.default.textColors.primary,
                height: 32,
                width: 32,
                borderRadius: 4,
                '&:hover': {
                    backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5),
                },
            },
        },
        MuiPickersCalendar: {
            transitionContainer: {
                minHeight: 236,
            },
        },
        MuiPickersDay: {
            hidden: {
                opacity: '0 !important',
                pointer: 'none !important',
            },
            current: {
                '& p': {
                    fontWeight: 'bold',
                },
            },
            day: {
                height: 32,
                width: 32,
                borderRadius: 4,
                margin: 4,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5),
                },
                '& p': __assign({}, theme_1.default.fonts.body),
            },
            daySelected: {
                backgroundColor: theme_1.default.colors.primaryDark,
                '&:hover': {
                    backgroundColor: theme_1.default.colors.primaryDark,
                },
            },
            dayDisabled: {
                cursor: 'none',
                opacity: 0.5,
            },
        },
    } }));
